import React from 'react'


const UnitedAtabEmiratesFlag = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_479_21884)">
<g clipPath="url(#clip1_479_21884)">
<path d="M0 2.5H20V7.5H0V2.5Z" fill="#00732F"/>
<path d="M0 7.5H20V12.5H0V7.5Z" fill="#F7F9FA"/>
<path d="M0 12.5H20V17.5H0V12.5Z" fill="black"/>
<path d="M0 2.5H6.875V17.5H0V2.5Z" fill="#FE0400"/>
</g>
</g>
<defs>
<clipPath id="clip0_479_21884">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_479_21884">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}

export default UnitedAtabEmiratesFlag





